"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddBtobsales = () => {
  const [customers, setCustomers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [form, setForm] = useState({
    order_id: "",
    invoice_no: "",
    invoice_link: "",
    company_name: "",
    customer_name: "",
    customer_email: "",
    customer_phone: "",
    GSTIN: "",
    billing_address: "",
    shipping_address: "",
    place_of_supply: "",
    customer_state: "",
    number_of_items: "",
    awb_number: "",
    courier_partner: "",
    tracking_link: "",
    invoice_amount: "",
    payment_mode: "",
    transaction_id: "",
    payment_date: "",
    advance_amount: "",
    pending_amount: "",
    total_amount: "",
    gst_amount: "",
  });

  /* ================= FETCH CUSTOMERS ================= */
  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const res = await axios.get(
        "https://logicx.premierlam.com/api/get-pixel-btobsales-customers",
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );
      setCustomers(res.data.data || []);
    } catch {
      toast.error("Failed to load customers");
    }
  };

  /* ================= COMPANY SELECT ================= */
  const customerOptions = customers.map((c) => ({
    value: c.company_name,
    label: c.company_name,
    data: c,
  }));

  const handleCompanySelect = (selected) => {
    const c = selected.data;
    setForm((prev) => ({
      ...prev,
      company_name: c.company_name,
      customer_name: c.customer_name,
      customer_email: c.customer_email,
      customer_phone: c.customer_phone,
      customer_state: c.customer_state,
      GSTIN: c.GSTIN,
      billing_address: c.billing_address,
    }));
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.customer_phone.length !== 10) {
      toast.error("Customer phone must be 10 digits");
      return;
    }

    try {
      setIsSubmitting(true);
      await axios.post(
        "https://logicx.premierlam.com/api/add-pixel-btobsales",
        form,
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("B2B sale added successfully!");
    } catch {
      toast.error("Failed to add B2B sale");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer />

      <div className="min-h-screen bg-gray-50 p-4">
        <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">Add B2B Sale</h2>

          <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">

            {/* COMPANY */}
            <div>
              <label className="text-sm font-medium">Company Name</label>
              <Select
                options={customerOptions}
                onChange={handleCompanySelect}
                placeholder="Select company"
              />
            </div>

            {[
              ["customer_name", "Customer Name"],
              ["customer_email", "Customer Email"],
              ["customer_phone", "Customer Phone"],
              ["customer_state", "Customer State"],
              ["GSTIN", "GSTIN"],
            ].map(([key, label]) => (
              <div key={key}>
                <label className="text-sm font-medium">{label}</label>
                <input
                  value={form[key]}
                  disabled
                  className="w-full border px-3 py-2 rounded bg-gray-100"
                />
              </div>
            ))}

            <div className="col-span-2">
              <label className="text-sm font-medium">Billing Address</label>
              <textarea
                value={form.billing_address}
                disabled
                className="w-full border px-3 py-2 rounded bg-gray-100"
              />
            </div>

            {Object.entries({
              order_id: "Order ID",
              invoice_no: "Invoice No",
              invoice_link: "Invoice Link",
              shipping_address: "Shipping Address",
              place_of_supply: "Place of Supply",
              number_of_items: "Number of Items",
              awb_number: "AWB Number",
              courier_partner: "Courier Partner",
              tracking_link: "Tracking Link",
              invoice_amount: "Invoice Amount",
              payment_mode: "Payment Mode",
              transaction_id: "Transaction ID",
              payment_date: "Payment Date",
              advance_amount: "Advance Amount",
              pending_amount: "Pending Amount",
              total_amount: "Total Amount",
              gst_amount: "GST Amount",
            }).map(([key, label]) => (
              <div key={key}>
                <label className="text-sm font-medium">{label}</label>
                <input
                  value={form[key]}
                  onChange={(e) =>
                    setForm({ ...form, [key]: e.target.value })
                  }
                  className="w-full border px-3 py-2 rounded"
                />
              </div>
            ))}

            <div className="col-span-2 flex justify-end gap-3">
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-orange-500 text-white px-6 py-2 rounded"
              >
                {isSubmitting ? "Saving..." : "Add Sale"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </>
  );
};

export default AddBtobsales;


// "use client";

// import { useEffect, useState } from "react";
// import axios from "axios";
// import Select from "react-select";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const AddBtobsales = () => {
//   const [customers, setCustomers] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const [form, setForm] = useState({
//     order_id: "",
//     invoice_no: "",
//     invoice_link: "",
//     company_name: "",
//     customer_name: "",
//     customer_email: "",
//     customer_phone: "",
//     GSTIN: "",
//     billing_address: "",
//     shipping_address: "",
//     place_of_supply: "",
//     customer_state: "",
//     number_of_items: "",
//     awb_number: "",
//     courier_partner: "",
//     tracking_link: "",
//     invoice_amount: "",
//     payment_mode: "",
//     transaction_id: "",
//     payment_date: "",
//     advance_amount: "",
//     pending_amount: "",
//     total_amount: "",
//     gst_amount: "",
//   });

//   /* ================= FETCH CUSTOMERS ================= */
//   useEffect(() => {
//     fetchCustomers();
//   }, []);

//   const fetchCustomers = async () => {
//     try {
//       const res = await axios.get(
//         "https://logicx.premierlam.com/api/get-pixel-btobsales-customers",
//         { headers: { authorization: localStorage.getItem("accessToken") } }
//       );
//       setCustomers(res.data.data || []);
//     } catch {
//       toast.error("Failed to load customers");
//     }
//   };

//   /* ================= COMPANY SELECT ================= */
//   const customerOptions = customers.map((c) => ({
//     value: c.company_name,
//     label: c.company_name,
//     data: c,
//   }));

//   const handleCompanySelect = (selected) => {
//     const c = selected.data;
//     setForm((prev) => ({
//       ...prev,
//       company_name: c.company_name,
//       customer_name: c.customer_name,
//       customer_email: c.customer_email,
//       customer_phone: c.customer_phone,
//       customer_state: c.customer_state,
//       GSTIN: c.GSTIN,
//       billing_address: c.billing_address,
//     }));
//   };

//   /* ================= SUBMIT ================= */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (form.customer_phone.length !== 10) {
//       toast.error("Customer phone must be 10 digits");
//       return;
//     }

//     try {
//       setIsSubmitting(true);

//       await axios.post(
//         "https://logicx.premierlam.com/api/add-pixel-btobsales",
//         form,
//         {
//           headers: {
//             authorization: localStorage.getItem("accessToken"),
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       toast.success("B2B sale added successfully!");
//     } catch {
//       toast.error("Failed to add B2B sale");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <>
//       <ToastContainer />

//       <div className="min-h-screen bg-gray-50 p-4">
//         <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow">

//           <h2 className="text-xl font-semibold mb-4">Add B2B Sale</h2>

//           <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">

//             {/* COMPANY */}
//             <div className="col-span-1">
//               <label className="text-sm">Company Name</label>
//               <Select
//                 options={customerOptions}
//                 onChange={handleCompanySelect}
//                 placeholder="Select company"
//               />
//             </div>

//             {[
//               ["customer_name", "Customer Name"],
//               ["customer_email", "Customer Email"],
//               ["customer_phone", "Customer Phone"],
//               ["customer_state", "Customer State"],
//               ["GSTIN", "GSTIN"],
//             ].map(([key, label]) => (
//               <input
//                 key={key}
//                 value={form[key]}
//                 placeholder={label}
//                 disabled
//                 className="border px-3 py-2 rounded bg-gray-100"
//               />
//             ))}

//             <textarea
//               value={form.billing_address}
//               disabled
//               placeholder="Billing Address"
//               className="col-span-2 border px-3 py-2 rounded bg-gray-100"
//             />

//             {/* OTHER INPUTS */}
//             {Object.entries({
//               order_id: "Order ID",
//               invoice_no: "Invoice No",
//               invoice_link: "Invoice Link",
//               shipping_address: "Shipping Address",
//               place_of_supply: "Place of Supply",
//               number_of_items: "No. of Items",
//               awb_number: "AWB Number",
//               courier_partner: "Courier Partner",
//               tracking_link: "Tracking Link",
//               invoice_amount: "Invoice Amount",
//               payment_mode: "Payment Mode",
//               transaction_id: "Transaction ID",
//               payment_date: "Payment Date",
//               advance_amount: "Advance Amount",
//               pending_amount: "Pending Amount",
//               total_amount: "Total Amount",
//               gst_amount: "GST Amount",
//             }).map(([key, label]) => (
//               <input
//                 key={key}
//                 value={form[key]}
//                 onChange={(e) =>
//                   setForm({ ...form, [key]: e.target.value })
//                 }
//                 placeholder={label}
//                 className="border px-3 py-2 rounded"
//               />
//             ))}

//             <div className="col-span-2 flex justify-end gap-3">
//               <button
//                 type="submit"
//                 disabled={isSubmitting}
//                 className="bg-orange-500 text-white px-6 py-2 rounded"
//               >
//                 {isSubmitting ? "Saving..." : "Add Sale"}
//               </button>
//             </div>

//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddBtobsales;
